import PropTypes from 'prop-types';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Col, FormGroup, Label, Row } from 'reactstrap';
import useTranslate from '../../hooks/useTranslate/useTranslate';
import AddressForm from '../AddressForm/AddressForm';
import GuestDetailsForm from '../GuestDetailsForm/GuestDetailsForm';
import SecondaryGuestsDropdown from '../SecondaryGuestsDropdown/SecondaryGuestsDropdown';
import SelectComponent from '../SelectComponent/SelectComponent';
import styles from './SingleGuestForm.module.css';

const arrivalTimes = Array.from({ length: 24 }, (_, i) => {
  const hour = String(i + 1).padStart(2, '0');
  const time = `${hour}:00`;
  return { option: time, code: time };
});

const SingleGuestForm = ({
  guestFormKey,
  numAdults,
  disabled,
  emailDisabled,
}) => {
  const { t } = useTranslate();
  const { control, errors, setValue, watch } = useFormContext();

  return (
    <div
      className={styles.SingleGuestForm__sectionContainer}
      data-testid="SingleGuestFormDiv"
    >
      <div className={styles.SingleGuestForm__sectionHeading}>
        <h2>{t('Guest Information')}</h2>
      </div>
      <GuestDetailsForm
        disabled={disabled}
        guestFormKey={guestFormKey}
        emailDisabled={emailDisabled}
      />
      <div className={styles.SingleGuestForm__sectionHeading}>
        <h2>{t('Address')}</h2>
      </div>
      <AddressForm disabled={disabled} guestFormKey={guestFormKey} />
      {numAdults > 1 && (
        <>
          <div className={styles.SingleGuestForm__sectionHeading}>
            <h2>{t('Add Guest')}</h2>
          </div>
          <SecondaryGuestsDropdown
            disabled={disabled}
            numAdults={numAdults}
            guestFormKey={guestFormKey}
          />
        </>
      )}
      <Row>
        <div className={styles.SingleGuestForm__sectionHeading}>
          <h2>{t('Additional Details and Preferences')}</h2>
        </div>
        <Col>
          <Label className={styles.SingleGuestForm__label}>
            {t('Please note any requests or requirements for your stay')}
          </Label>
          <FormGroup className={styles.SingleGuestForm__formGroup}>
            <Controller
              name={`bookingsGuestValues[${guestFormKey}].notes`}
              control={control}
              render={({ field }) => (
                <textarea
                  type="text"
                  maxLength="200"
                  rows={6}
                  style={{ width: '100%' }}
                  className={styles.SingleGuestForm__input}
                  {...field}
                  placeholder=" "
                  aria-label={`bookingsGuestValues[${guestFormKey}].notes`}
                />
              )}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col md="6">
          <SelectComponent
            name={`bookingsGuestValues[${guestFormKey}].arrivalTime`}
            control={control}
            label={
              <div>
                {t('Arrival Time')}
                <span style={{ textTransform: 'lowercase', marginLeft: 4 }}>
                  (optional)
                </span>
              </div>
            }
            setValue={setValue}
            options={arrivalTimes}
            watch={watch}
            errors={errors}
            disabled={disabled}
            placeholderOption={'Estimated arrival time at hotel'}
            allowEmptySelection
          />
        </Col>
      </Row>
    </div>
  );
};
SingleGuestForm.propTypes = {
  numAdults: PropTypes.number,
  disabled: PropTypes.bool,
  guestFormKey: PropTypes.string,
  emailDisabled: PropTypes.bool,
};
export default SingleGuestForm;
